(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-hero-description')) {
    customElements.define(
      'collection-hero-description',
      class CollectionHeroDescription extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dataset.initialized = 'true';
          this.description = this.querySelector('[data-collection-hero-description-content]');
          this.toggleButton = this.querySelector('[data-collection-hero-description-toggle]');

          if (!this.description || !this.toggleButton) return;

          this.handleToggle = () => {
            const isExpanded = this.dataset.expanded === 'true';
            const willExpand = !isExpanded;
            this.dataset.expanded = String(willExpand);
            this.toggleButton.setAttribute('aria-expanded', String(willExpand));

            if (!willExpand) {
              this.checkOverflow();
            }
          };

          this.toggleButton.addEventListener('click', this.handleToggle);
          this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
          this.resizeObserver.observe(this);
          requestAnimationFrame(() => this.checkOverflow());
        }

        disconnectedCallback() {
          this.toggleButton?.removeEventListener('click', this.handleToggle);
          this.resizeObserver?.disconnect();
        }

        checkOverflow() {
          if (!this.description || !this.toggleButton || this.dataset.expanded === 'true') return;

          this.dataset.collapsible = 'true';
          this.toggleButton.hidden = false;

          requestAnimationFrame(() => {
            const hasOverflow = this.description.scrollHeight > this.description.clientHeight + 1;
            this.dataset.collapsible = String(hasOverflow);
            this.toggleButton.hidden = !hasOverflow;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["connected-points"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registryKey = '__ksConnectedPoints';
    const state = window[registryKey] || {
      initialized: false,
      instances: new Map(),
      raf: 0,
      reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)'),
    };

    window[registryKey] = state;

    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

    const scheduleUpdate = () => {
      if (state.raf) return;
      state.raf = window.requestAnimationFrame(() => {
        state.raf = 0;
        state.instances.forEach((instance) => instance.update());
      });
    };

    const readSchemeColor = (element, property, fallback) => {
      if (!element) return fallback;
      return window.getComputedStyle(element).getPropertyValue(property).trim() || fallback;
    };

    const setup = (section) => {
      if (!section || section.dataset.connectedPointsInitialized === 'true') return;

      const track = section.querySelector('[data-connected-points-track]');
      const svg = section.querySelector('[data-connected-points-svg]');
      const path = section.querySelector('[data-connected-points-path]');
      const points = [...section.querySelectorAll('[data-connected-points-point]')];
      const dots = [...section.querySelectorAll('[data-connected-points-dot]')];
      const activeScheme = section.querySelector('[data-connected-points-active-scheme]');
      if (!track || !points.length) return;

      section.dataset.connectedPointsInitialized = 'true';
      section.classList.add('is-enhanced');

      section.style.setProperty(
        '--ks-connected-active-background',
        readSchemeColor(activeScheme, '--scheme-background-solid', 'var(--scheme-background-solid)')
      );
      section.style.setProperty(
        '--ks-connected-active-foreground',
        readSchemeColor(activeScheme, '--scheme-accent', 'var(--scheme-accent)')
      );

      let pathLength = 0;
      let pathStartY = 0;
      let pathEndY = 1;
      let needsMeasure = true;

      const measure = () => {
        needsMeasure = false;
        if (!svg || !path || dots.length < 2) return;

        const coordinates = dots.map((dot) => {
          const point = dot.closest('[data-connected-points-point]');
          return {
            x: point.offsetLeft + dot.offsetLeft + (dot.offsetWidth / 2),
            y: point.offsetTop + dot.offsetTop,
          };
        });

        svg.setAttribute('viewBox', `0 0 ${Math.max(1, track.clientWidth)} ${Math.max(1, track.clientHeight)}`);
        path.setAttribute(
          'd',
          coordinates.map((point, index) => `${index === 0 ? 'M' : 'L'} ${point.x.toFixed(2)} ${point.y.toFixed(2)}`).join(' ')
        );

        pathLength = path.getTotalLength();
        pathStartY = coordinates[0].y;
        pathEndY = coordinates[coordinates.length - 1].y;
        path.style.strokeDasharray = `${pathLength}`;
      };

      const update = () => {
        if (needsMeasure) measure();

        const rect = section.getBoundingClientRect();
        const active = rect.top <= 0;
        section.classList.toggle('is-active', active);

        if (state.reducedMotion.matches) {
          points.forEach((point) => point.classList.add('is-visible'));
          if (path) path.style.strokeDashoffset = '0';
          return;
        }

        const revealLine = window.innerHeight * 0.74;
        const trackRect = track.getBoundingClientRect();
        const revealedTrackY = revealLine - trackRect.top;
        const progress = clamp((revealedTrackY - pathStartY) / Math.max(1, pathEndY - pathStartY));

        if (path && pathLength) {
          path.style.strokeDashoffset = `${pathLength * (1 - progress)}`;
        }

        points.forEach((point) => {
          if (point.classList.contains('is-visible')) return;
          const dot = point.querySelector('[data-connected-points-dot]');
          if (!dot || dot.getBoundingClientRect().top <= revealLine) {
            point.classList.add('is-visible');
          }
        });
      };

      const resizeObserver = window.ResizeObserver
        ? new ResizeObserver(() => {
            needsMeasure = true;
            scheduleUpdate();
          })
        : null;

      resizeObserver?.observe(track);
      points.forEach((point) => resizeObserver?.observe(point));

      const instance = {
        update,
        invalidate() {
          needsMeasure = true;
        },
        destroy() {
          resizeObserver?.disconnect();
          state.instances.delete(section);
          delete section.dataset.connectedPointsInitialized;
        },
      };

      state.instances.set(section, instance);
      update();
    };

    const setupAll = (scope = document) => {
      if (scope.matches?.('[data-connected-points]')) setup(scope);
      scope.querySelectorAll?.('[data-connected-points]').forEach(setup);
    };

    if (!state.initialized) {
      state.initialized = true;
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', () => {
        state.instances.forEach((instance) => instance.invalidate());
        scheduleUpdate();
      }, { passive: true });
      state.reducedMotion.addEventListener?.('change', scheduleUpdate);

      document.addEventListener('shopify:section:load', (event) => {
        setupAll(event.target);
        scheduleUpdate();
      });

      document.addEventListener('shopify:section:unload', (event) => {
        state.instances.forEach((instance, section) => {
          if (event.target.contains(section)) instance.destroy();
        });
      });
    }

    setupAll();
    scheduleUpdate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["facility-map"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('facility-map')) {
    customElements.define('facility-map', class FacilityMap extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.canvas = this.querySelector('[data-map-canvas]');
        this.stage = this.querySelector('.ks-facility-map__stage');
        this.viewport = this.querySelector('[data-map-viewport]');
        this.progress = this.querySelector('[data-map-progress]');
        this.pins = [...this.querySelectorAll('[data-map-pin]')];
        this.selectors = [...this.querySelectorAll('[data-map-selector]')];
        this.previewRegion = this.querySelector('[data-map-preview-region]');
        this.previews = [...this.querySelectorAll('[data-map-preview]')];
        this.previewLinks = [...this.querySelectorAll('[data-map-preview-link]')];
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.canvas || !this.pins.length) return;

        this.pins.forEach((pin, index) => {
          const link = pin.querySelector('a');
          link?.addEventListener('mouseenter', () => {
            this.select(index, false, true);
          });
          link?.addEventListener('focus', () => {
            this.select(index, false, true);
          });
          link?.addEventListener('click', (event) => {
            event.preventDefault();
            this.select(index, true, true);
          });
        });

        this.selectors.forEach((selector, index) => {
          selector.addEventListener('click', (event) => {
            event.preventDefault();
            this.select(index, true, true);
          });
        });

        this.previewLinks.forEach((link) => {
          link.addEventListener('click', (event) => {
            this.navigateToFacility(event, link);
          });
        });

        this.activeIndex = 0;
        this.handleViewportChange = () => {
          if (this.previewFrame) return;
          this.previewFrame = requestAnimationFrame(() => {
            this.positionPreview();
            this.previewFrame = null;
          });
        };
        window.addEventListener('scroll', this.handleViewportChange, { passive: true });
        window.addEventListener('resize', this.handleViewportChange, { passive: true });
        this.viewport.addEventListener('scroll', () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.updateMapProgress();
            this.scrollFrame = null;
          });
        }, { passive: true });
        this.resizeObserver = new ResizeObserver(() => {
          this.placePins();
          this.updateMapProgress();
          this.positionPreview();
          if (window.matchMedia('(max-width: 767px)').matches) {
            requestAnimationFrame(() => this.centerMap(this.activeIndex, 'auto'));
          }
        });
        this.resizeObserver.observe(this.canvas);
        this.placePins();
        this.updateMapProgress();
        this.select(0, window.matchMedia('(max-width: 767px)').matches, false);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        window.removeEventListener('scroll', this.handleViewportChange);
        window.removeEventListener('resize', this.handleViewportChange);
        if (this.previewFrame) cancelAnimationFrame(this.previewFrame);
      }

      project(longitude, latitude) {
        const radians = Math.PI / 180;
        const a1 = 1.340264;
        const a2 = -0.081106;
        const a3 = 0.000893;
        const a4 = 0.003796;
        const m = Math.sqrt(3) / 2;
        const lambda = longitude * radians;
        const phi = latitude * radians;
        const l = Math.asin(m * Math.sin(phi));
        const l2 = l * l;
        const l6 = l2 * l2 * l2;
        const x = lambda * Math.cos(l) / (m * (a1 + 3 * a2 * l2 + l6 * (7 * a3 + 9 * a4 * l2)));
        const y = l * (a1 + a2 * l2 + l6 * (a3 + a4 * l2));
        const scale = 171.5548723607079;

        return [500 + scale * x, 250 - scale * y];
      }

      placePins() {
        const width = this.canvas.clientWidth;
        const height = this.canvas.clientHeight;
        const mapViewLeft = Number(this.dataset.mapViewX || 0);
        const mapViewTop = Number(this.dataset.mapViewY || 24);
        const mapViewWidth = Number(this.dataset.mapViewWidth || 1000);
        const mapViewHeight = Number(this.dataset.mapViewHeight || 452);
        const anchors = [];

        this.pins.forEach((pin, index) => {
          const longitude = Number(pin.dataset.lon);
          const latitude = Number(pin.dataset.lat);
          const [mapX, mapY] = this.project(longitude, latitude);
          const normalizedY = (mapY - mapViewTop) / mapViewHeight;
          const normalizedX = (mapX - mapViewLeft) / mapViewWidth;
          const anchorX = normalizedX * width;
          const anchorY = normalizedY * height;
          let offsetX = 0;
          let offsetY = 0;
          const nearby = anchors.filter((point) => Math.hypot(point.x - anchorX, point.y - anchorY) < 38);

          if (nearby.length) {
            const angle = -Math.PI / 2 + (index * 2.399963229728653);
            const radius = 27 + Math.floor(nearby.length / 5) * 10;
            offsetX = Math.cos(angle) * radius;
            offsetY = Math.sin(angle) * radius;
          }

          pin.style.left = `${normalizedX * 100}%`;
          pin.style.top = `${normalizedY * 100}%`;
          pin.style.setProperty('--pin-offset-x', `${offsetX}px`);
          pin.style.setProperty('--pin-offset-y', `${offsetY}px`);
          pin.style.setProperty('--pin-leader-length', `${Math.hypot(offsetX, offsetY)}px`);
          pin.style.setProperty('--pin-leader-angle', `${Math.atan2(offsetY, offsetX) * 180 / Math.PI}deg`);
          pin.dataset.anchorX = String(anchorX);
          pin.dataset.visualX = String(anchorX + offsetX);
          pin.dataset.visualY = String(anchorY + offsetY);
          anchors.push({ x: anchorX, y: anchorY });
        });
      }

      select(index, centerMap = false, showPreview = true) {
        const activePin = this.pins[index];
        if (!activePin) return;
        this.activeIndex = index;

        this.pins.forEach((pin, pinIndex) => {
          const button = pin.querySelector('a');
          const isActive = pinIndex === index;
          button?.classList.toggle('is-active', isActive);
        });

        this.selectors.forEach((selector, selectorIndex) => {
          const isActive = selectorIndex === index;
          selector.classList.toggle('is-active', isActive);
        });

        if (this.previewRegion) {
          this.previewRegion.hidden = !showPreview;
        }

        this.previews.forEach((preview, previewIndex) => {
          preview.hidden = !showPreview || previewIndex !== index;
        });

        if (showPreview) {
          requestAnimationFrame(() => this.positionPreview());
        }

        if (centerMap) {
          requestAnimationFrame(() => {
            const behavior = this.reduceMotion ? 'auto' : 'smooth';
            this.centerMap(index, behavior);
            this.centerSelector(index, behavior);
          });
        }
      }

      navigateToFacility(event, link) {
        const targetId = link.hash.slice(1);
        const target = document.getElementById(targetId);
        if (!target) return;

        event.preventDefault();

        if (window.location.hash !== link.hash) {
          window.history.pushState(null, '', link.hash);
        }

        target.scrollIntoView({
          behavior: this.reduceMotion ? 'auto' : 'smooth',
          block: 'start'
        });
        target.focus({ preventScroll: true });
      }

      positionPreview() {
        if (!this.previewRegion || this.previewRegion.hidden || !this.stage) return;
        const stageRect = this.stage.getBoundingClientRect();
        const gutter = window.matchMedia('(max-width: 767px)').matches ? 12 : 20;
        const visibleBottom = Math.min(stageRect.bottom - gutter, window.innerHeight - gutter);
        const bottomOffset = Math.max(gutter, stageRect.bottom - visibleBottom);
        this.previewRegion.style.setProperty('--facility-map-preview-bottom', `${bottomOffset}px`);
      }

      centerMap(index, behavior = 'smooth') {
        const activePin = this.pins[index];
        if (!activePin) return;
        const anchorX = Number(activePin.dataset.anchorX || 0);
        const maxLeft = Math.max(0, this.canvas.clientWidth - this.viewport.clientWidth);
        const targetLeft = Math.max(0, Math.min(maxLeft, anchorX - this.viewport.clientWidth / 2));
        this.viewport.scrollTo({ left: targetLeft, behavior });
      }

      updateMapProgress() {
        if (!this.progress || !this.viewport) return;
        const viewportWidth = this.viewport.clientWidth;
        const scrollWidth = this.viewport.scrollWidth;
        const maxScrollLeft = Math.max(0, scrollWidth - viewportWidth);
        const progressValue = maxScrollLeft > 0 ? this.viewport.scrollLeft / maxScrollLeft : 0;

        this.progress.hidden = maxScrollLeft <= 4;
        this.progress.style.setProperty('--facility-map-progress-count', String(Math.max(1, scrollWidth / viewportWidth)));
        this.progress.style.setProperty('--facility-map-progress-index', String(viewportWidth > 0 ? this.viewport.scrollLeft / viewportWidth : 0));
        this.progress.setAttribute('aria-valuenow', String(Math.round(progressValue * 100)));
      }

      centerSelector(index, behavior = 'smooth') {
        const selector = this.selectors[index];
        const rail = selector?.parentElement;
        if (!selector || !rail) return;
        const maxLeft = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const targetLeft = Math.max(0, Math.min(maxLeft, selector.offsetLeft - (rail.clientWidth - selector.clientWidth) / 2));
        rail.scrollTo({ left: targetLeft, behavior });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-maker-marque"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registryKey = '__ksFloatingMakerMarque';
    const state = window[registryKey] || { initialized: false, instances: new Set() };
    window[registryKey] = state;
    if (!state.instances) state.instances = new Set();

    const shuffle = (items) => {
      const shuffled = items.slice();
      for (let index = shuffled.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
      }
      return shuffled;
    };

    const createMakerItem = (item, index) => {
      const floatingItem = document.createElement('div');
      floatingItem.className = 'floating-maker-marque__item';
      floatingItem.dataset.floatingMakerMarqueItem = '';
      floatingItem.dataset.index = String(index);

      const card = document.createElement(item.url ? 'a' : 'div');
      card.className = 'floating-maker-marque__card';
      if (item.url) card.href = item.url;

      const image = document.createElement('img');
      image.className = 'floating-maker-marque__image';
      image.src = item.image;
      image.alt = item.alt || item.name || '';
      image.loading = index < 8 ? 'eager' : 'lazy';
      image.decoding = 'async';
      image.draggable = false;
      const media = document.createElement('span');
      media.className = 'floating-maker-marque__media';
      media.appendChild(image);
      card.appendChild(media);

      const overlay = document.createElement('span');
      overlay.className = 'floating-maker-marque__card-overlay';

      const name = document.createElement('span');
      name.className = 'floating-maker-marque__name';
      name.textContent = item.name;
      overlay.appendChild(name);

      if (item.role) {
        const role = document.createElement('span');
        role.className = 'floating-maker-marque__role';
        role.textContent = item.role;
        overlay.appendChild(role);
      }

      card.appendChild(overlay);
      floatingItem.appendChild(card);
      return floatingItem;
    };

    const setup = (section) => {
      if (!section || section.dataset.floatingMakerMarqueInitialized === 'true') return;

      const stage = section.querySelector('[data-floating-maker-marque-stage]');
      const heading = section.querySelector('[data-floating-maker-marque-heading]');
      const headingText = section.querySelector('[data-floating-maker-marque-heading-text]');
      const underLayer = section.querySelector('[data-floating-maker-marque-under]');
      const overLayer = section.querySelector('[data-floating-maker-marque-over]');
      const dataNode = section.querySelector('[data-floating-maker-marque-data]');
      const emptyNode = section.querySelector('[data-floating-maker-marque-empty]');
      if (!stage || !underLayer || !overLayer || !dataNode) return;

      let candidates = [];
      try {
        candidates = JSON.parse(dataNode.textContent || '[]');
      } catch (error) {
        candidates = [];
      }

      const selected = shuffle(candidates).slice(0, 20);
      if (selected.length === 0) {
        if (emptyNode) emptyNode.hidden = false;
        section.dataset.floatingMakerMarqueInitialized = 'true';
        return;
      }

      const items = selected.map((item, index) => {
        const floatingItem = createMakerItem(item, index);
        const laneIndex = index % 4;
        if (laneIndex === 2) overLayer.appendChild(floatingItem);
        else underLayer.appendChild(floatingItem);
        return floatingItem;
      });

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let frameId = null;
      let startTime = performance.now();
      let resizeObserver = null;

      const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
      const responsiveNumber = (desktopKey, mobileKey) => {
        const desktopValue = Number(section.dataset[desktopKey]) || 0;
        const mobileValue = Number(section.dataset[mobileKey]) || desktopValue;
        return isMobile() ? mobileValue : desktopValue;
      };

      const laneMultiplier = (index) => {
        const lane = ((index % 4) + 4) % 4;
        if (lane === 0) return -1;
        if (lane === 2) return 1;
        return 0;
      };

      const fitHeading = () => {
        if (!heading || !headingText) return;

        heading.style.setProperty('--floating-maker-marque-heading-fit', '100px');
        const measuredWidth = headingText.getBoundingClientRect().width;
        if (!measuredWidth) return;

        const widthTarget = stage.clientWidth * (isMobile() ? 0.94 : 0.96);
        const heightLimit = stage.clientHeight * (isMobile() ? 0.16 : 0.22);
        const fittedSize = Math.min((100 * widthTarget) / measuredWidth, heightLimit);
        heading.style.setProperty('--floating-maker-marque-heading-fit', `${Math.max(18, fittedSize)}px`);
      };

      const render = (elapsedSeconds) => {
        const width = stage.clientWidth;
        const height = stage.clientHeight;
        const itemSize = responsiveNumber('sizeDesktop', 'sizeMobile');
        const visibleCount = Math.max(1, responsiveNumber('visibleDesktop', 'visibleMobile'));
        const spacing = width / visibleCount;
        const curveHeight = responsiveNumber('curveDesktop', 'curveMobile');
        const duration = Math.max(8, responsiveNumber('durationDesktop', 'durationMobile'));
        const peakScaleBoost = Math.max(0, (Number(section.dataset.peakScale) || 300) / 100 - 1);
        const troughScale = Math.max(0.6, 1 - peakScaleBoost * 0.45);
        const direction = section.dataset.direction === 'rtl' ? 'rtl' : 'ltr';
        const entryBuffer = Math.max(16, Math.round(itemSize * 0.18));
        const startX = -itemSize - entryBuffer;
        const endX = width + entryBuffer;
        const pathRange = Math.max(1, endX - startX);
        const pixelsPerSecond = pathRange / duration;
        const loopLength = Math.max(spacing * items.length, pathRange + spacing);
        const travelDistance = elapsedSeconds * pixelsPerSecond;

        items.forEach((item, index) => {
          let x = direction === 'rtl'
            ? endX - (index * spacing) - travelDistance
            : startX + (index * spacing) + travelDistance;

          while (x > endX) x -= loopLength;
          while (x < startX) x += loopLength;

          const pathProgress = direction === 'rtl'
            ? Math.min(Math.max((endX - x) / pathRange, 0), 1)
            : Math.min(Math.max((x - startX) / pathRange, 0), 1);
          const arcProgress = Math.sin(pathProgress * Math.PI);
          const scaleProgress = Math.pow(arcProgress, 2.2);
          const y = (height * 0.5) - (itemSize * 0.5) + (laneMultiplier(index) * curveHeight * arcProgress);
          const scale = troughScale + ((1 + peakScaleBoost - troughScale) * scaleProgress);
          item.style.setProperty('--floating-maker-marque-item-size', `${itemSize}px`);
          item.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${scale})`;
        });
      };

      const animate = (now) => {
        render((now - startTime) / 1000);
        frameId = window.requestAnimationFrame(animate);
      };

      const stop = () => {
        if (!frameId) return;
        window.cancelAnimationFrame(frameId);
        frameId = null;
      };

      const start = () => {
        stop();
        if (reducedMotion.matches) {
          render(0);
          section.classList.add('is-ready');
          return;
        }
        startTime = performance.now();
        render(0);
        section.classList.add('is-ready');
        frameId = window.requestAnimationFrame(animate);
      };

      const handleMotionChange = () => start();
      reducedMotion.addEventListener('change', handleMotionChange);

      if (window.ResizeObserver) {
        resizeObserver = new window.ResizeObserver(() => {
          fitHeading();
          if (reducedMotion.matches) render(0);
        });
        resizeObserver.observe(stage);
      }

      fitHeading();
      document.fonts?.ready.then(fitHeading);
      start();
      section.dataset.floatingMakerMarqueInitialized = 'true';

      const instance = {
        section,
        destroy() {
          stop();
          reducedMotion.removeEventListener('change', handleMotionChange);
          resizeObserver?.disconnect();
          state.instances.delete(instance);
          delete section.dataset.floatingMakerMarqueInitialized;
        },
      };

      state.instances.add(instance);
    };

    const setupAll = (scope = document) => {
      if (scope.matches?.('[data-floating-maker-marque]')) setup(scope);
      scope.querySelectorAll?.('[data-floating-maker-marque]').forEach(setup);
    };

    if (!state.initialized) {
      state.initialized = true;
      document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        state.instances.forEach((instance) => {
          if (event.target.contains(instance.section)) instance.destroy();
        });
      });
    }

    setupAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-masonry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const gridSelector = '[data-image-masonry-grid]';

    function normalizeLogos(grid) {
      grid.querySelectorAll('.ks-image-masonry__image').forEach((image) => {
        const visual = image.closest('.ks-image-masonry__visual');
        const availableWidth = visual?.clientWidth || 0;
        const imageRatio = image.naturalWidth / image.naturalHeight;

        if (!availableWidth || !Number.isFinite(imageRatio) || imageRatio <= 0) return;

        const targetHeight = Math.min(64, Math.max(44, availableWidth * 0.26));
        const targetArea = availableWidth * targetHeight;
        let targetWidth = Math.sqrt(targetArea * imageRatio);
        const calculatedHeight = targetWidth / imageRatio;
        const maxHeight = Number.parseFloat(window.getComputedStyle(image).maxHeight) || calculatedHeight;
        const scale = Math.min(1, availableWidth / targetWidth, maxHeight / calculatedHeight);

        targetWidth *= scale;
        image.style.width = `${targetWidth}px`;
      });
    }

    function layoutGrid(grid) {
      if (!grid?.matches(gridSelector)) return;

      const items = Array.from(grid.querySelectorAll('.ks-image-masonry__item'));

      normalizeLogos(grid);

      items.forEach((item) => {
        item.style.gridRowEnd = 'auto';
        item.style.gridColumnStart = 'auto';
      });

      const renderedColumns = window.getComputedStyle(grid).gridTemplateColumns.split(' ').length;
      const columnCount = Math.max(1, Math.round(renderedColumns / 2));
      const finalRowCount = items.length % columnCount;

      if (finalRowCount > 0) {
        const finalRowStart = columnCount - finalRowCount + 1;

        items.slice(-finalRowCount).forEach((item, index) => {
          item.style.gridColumnStart = String(finalRowStart + (index * 2));
        });
      }

      const rowHeight = Number.parseFloat(window.getComputedStyle(grid).gridAutoRows);
      if (!Number.isFinite(rowHeight) || rowHeight <= 0) return;

      items.forEach((item) => {
        const itemStyles = window.getComputedStyle(item);
        const itemHeight = item.getBoundingClientRect().height;
        const marginBottom = Number.parseFloat(itemStyles.marginBottom) || 0;
        const rowSpan = Math.max(1, Math.ceil((itemHeight + marginBottom) / rowHeight));

        item.style.gridRowEnd = `span ${rowSpan}`;
      });
    }

    function initGrid(grid) {
      if (!grid || grid.dataset.imageMasonryInitialized === 'true') return;
      grid.dataset.imageMasonryInitialized = 'true';

      let layoutFrame;
      const scheduleLayout = () => {
        window.cancelAnimationFrame(layoutFrame);
        layoutFrame = window.requestAnimationFrame(() => layoutGrid(grid));
      };

      grid.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', scheduleLayout, { once: true });
      });

      if (typeof ResizeObserver === 'function') {
        let previousGridWidth = 0;
        const resizeObserver = new ResizeObserver(([entry]) => {
          const nextGridWidth = entry?.contentRect?.width || 0;
          if (Math.abs(nextGridWidth - previousGridWidth) < 0.5) return;

          previousGridWidth = nextGridWidth;
          scheduleLayout();
        });
        resizeObserver.observe(grid);
        grid.__ksImageMasonryResizeObserver = resizeObserver;
      } else {
        window.addEventListener('resize', scheduleLayout, { passive: true });
      }

      scheduleLayout();
    }

    function initImageMasonry(root = document) {
      if (root.matches?.(gridSelector)) initGrid(root);
      root.querySelectorAll?.(gridSelector).forEach(initGrid);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initImageMasonry(), { once: true });
    } else {
      initImageMasonry();
    }

    document.addEventListener('shopify:section:load', (event) => initImageMasonry(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pinned-panels"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registryKey = '__ksPinnedPanels';
    const state = window[registryKey] || {
      instances: new Map(),
      librariesPromise: null,
      listenersReady: false,
      reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)'),
    };

    window[registryKey] = state;

    const loadScript = (src, isReady) => new Promise((resolve, reject) => {
      if (isReady()) {
        resolve();
        return;
      }

      const absoluteSrc = new URL(src, window.location.href).href;
      let script = [...document.scripts].find((candidate) => candidate.src === absoluteSrc);

      const handleLoad = () => {
        if (isReady()) resolve();
        else reject(new Error(`Loaded script without expected global: ${absoluteSrc}`));
      };

      if (script) {
        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', reject, { once: true });
        window.setTimeout(() => {
          if (isReady()) resolve();
        }, 0);
        return;
      }

      script = document.createElement('script');
      script.src = absoluteSrc;
      script.async = false;
      script.dataset.pinnedPanelsLibrary = 'true';
      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    const ensureLibraries = (section) => {
      if (window.gsap && window.ScrollTrigger) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        return Promise.resolve();
      }

      if (!state.librariesPromise) {
        state.librariesPromise = loadScript(section.dataset.gsapSrc, () => Boolean(window.gsap))
          .then(() => loadScript(section.dataset.scrollTriggerSrc, () => Boolean(window.ScrollTrigger)))
          .then(() => window.gsap.registerPlugin(window.ScrollTrigger))
          .catch((error) => {
            state.librariesPromise = null;
            throw error;
          });
      }

      return state.librariesPromise;
    };

    const numberFromProperty = (element, property, fallback) => {
      const value = Number.parseFloat(window.getComputedStyle(element).getPropertyValue(property));
      return Number.isFinite(value) ? value : fallback;
    };

    const destroy = (section) => {
      const instance = state.instances.get(section);
      if (!instance) return;

      instance.resizeObserver?.disconnect();
      instance.cleanup?.();
      instance.context?.revert();
      instance.panels.forEach((panel) => {
        panel.classList.remove('is-static-mobile');
        panel.style.removeProperty('height');
        panel.style.removeProperty('opacity');
        panel.style.removeProperty('transform');
        panel.style.removeProperty('z-index');
      });
      section.classList.remove('is-enhanced');
      delete section.dataset.pinnedPanelsInitialized;
      state.instances.delete(section);
    };

    const setup = async (section) => {
      if (!section || section.dataset.pinnedPanelsInitialized === 'true') return;

      const panels = [...section.querySelectorAll(':scope [data-pinned-panel]')];
      if (!panels.length || state.reducedMotion.matches) return;

      section.dataset.pinnedPanelsInitialized = 'true';

      try {
        await ensureLibraries(section);
      } catch (error) {
        console.warn('Pinned panels could not initialize.', error);
        delete section.dataset.pinnedPanelsInitialized;
        return;
      }

      if (!section.isConnected || state.reducedMotion.matches) {
        delete section.dataset.pinnedPanelsInitialized;
        return;
      }

      section.classList.add('is-enhanced');

      let headerOffset = 0;

      const updateHeaderOffset = () => {
        const header = document.querySelector('.ks-header');
        const headerHeight = Math.max(0, Math.ceil(header?.getBoundingClientRect().height || 0));
        const value = `${headerHeight}px`;

        headerOffset = headerHeight;

        if (section.style.getPropertyValue('--ks-pinned-panel-header-offset') !== value) {
          section.style.setProperty('--ks-pinned-panel-header-offset', value);
        }
      };

      updateHeaderOffset();

      panels.forEach((panel, index) => {
        panel.style.zIndex = String(index + 1);
      });

      let context;
      let modeSignature = '';
      const updatePanelModes = () => {
        const mobile = window.matchMedia('(max-width: 767px)').matches;
        const availableHeight = Math.max(0, document.documentElement.clientHeight - headerOffset);
        const staticPanels = panels.map((panel) => {
          const inner = panel.querySelector('[data-pinned-panel-inner]');
          return mobile && (inner?.scrollHeight || panel.scrollHeight) > availableHeight + 2;
        });
        const signature = `${mobile}:${staticPanels.join(',')}`;
        if (signature === modeSignature) return;
        modeSignature = signature;
        context?.revert();
        panels.forEach((panel, index) => panel.classList.toggle('is-static-mobile', staticPanels[index]));
        context = window.gsap.context(() => {
        panels.slice(0, -1).forEach((panel) => {
          const inner = panel.querySelector('[data-pinned-panel-inner]');
          if (!inner || panel.classList.contains('is-static-mobile')) return;

          const mobile = window.matchMedia('(max-width: 767px)').matches;
          const endOpacity = numberFromProperty(
            section,
            mobile ? '--ks-pinned-panel-opacity-mobile' : '--ks-pinned-panel-opacity-desktop',
            mobile ? 0.7 : 0.5
          );

          const timeline = window.gsap.timeline({
            scrollTrigger: {
              trigger: panel,
              start: () => `top top+=${headerOffset}`,
              end: () => `+=${panel.offsetHeight}`,
              scrub: true,
              invalidateOnRefresh: true,
              onRefreshInit: () => {
                updateHeaderOffset();
              },
            },
          });

          timeline
            .fromTo(
              panel,
              { opacity: 1 },
              { opacity: endOpacity, duration: 0.9, ease: 'none' }
            )
            .to(panel, { opacity: 0, duration: 0.1, ease: 'none' });
        });
        }, section);
        const instance = state.instances.get(section);
        if (instance) instance.context = context;
      };

      updatePanelModes();

      let refreshTimer = 0;
      const refresh = () => {
        window.clearTimeout(refreshTimer);
        refreshTimer = window.setTimeout(() => {
          if (!section.isConnected || section.dataset.pinnedPanelsInitialized !== 'true') return;
          updateHeaderOffset();
          updatePanelModes();
          window.ScrollTrigger?.refresh();
        }, 80);
      };

      const resizeObserver = window.ResizeObserver ? new ResizeObserver(refresh) : null;
      resizeObserver?.observe(section);
      const header = document.querySelector('.ks-header');
      if (header) resizeObserver?.observe(header);
      panels.forEach((panel) => resizeObserver?.observe(panel.querySelector('[data-pinned-panel-inner]') || panel));
      section.querySelectorAll('img, video').forEach((media) => {
        if (media instanceof HTMLImageElement && media.complete) return;
        media.addEventListener(media instanceof HTMLVideoElement ? 'loadedmetadata' : 'load', refresh, { once: true });
      });

      window.addEventListener('resize', refresh, { passive: true });
      const cleanup = () => {
        window.clearTimeout(refreshTimer);
        window.removeEventListener('resize', refresh);
      };
      state.instances.set(section, { context, panels, resizeObserver, cleanup });
      window.ScrollTrigger.refresh();
    };

    const setupAll = (scope = document) => {
      if (scope.matches?.('[data-pinned-panels]')) setup(scope);
      scope.querySelectorAll?.('[data-pinned-panels]').forEach(setup);
    };

    if (!state.listenersReady) {
      state.listenersReady = true;

      document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        state.instances.forEach((instance, section) => {
          if (event.target.contains(section)) destroy(section);
        });
      });
      document.addEventListener('shopify:block:select', (event) => {
        const section = event.target.closest?.('[data-pinned-panels]');
        if (!section) return;
        window.ScrollTrigger?.refresh();
        event.target.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
      });
      state.reducedMotion.addEventListener?.('change', () => {
        state.instances.forEach((instance, section) => destroy(section));
        setupAll();
      });
    }

    setupAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-bento-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const key = '__ksScrollBentoGallery';
    const state = window[key] || {
      instances: new Map(),
      raf: null,
      resizeRaf: null,
      initialized: false,
      lastViewportWidth: document.documentElement.clientWidth || window.innerWidth || 0,
      reduceMotionQuery: window.matchMedia('(prefers-reduced-motion: reduce)'),
      desktopQuery: window.matchMedia('(min-width: 768px)'),
    };

    window[key] = state;
    state.reduceMotionQuery = state.reduceMotionQuery || window.matchMedia('(prefers-reduced-motion: reduce)');
    state.desktopQuery = state.desktopQuery || window.matchMedia('(min-width: 768px)');
    state.lastViewportWidth = state.lastViewportWidth || document.documentElement.clientWidth || window.innerWidth || 0;

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const progressBetween = (progress, startPercent, endPercent) => {
      const start = clamp((Number.parseFloat(startPercent) || 0) / 100, 0, 0.99);
      const end = clamp((Number.parseFloat(endPercent) || 100) / 100, start + 0.01, 1);
      return clamp((progress - start) / (end - start), 0, 1);
    };
    const getViewportHeight = () => (
      (window.visualViewport && window.visualViewport.height)
      || window.innerHeight
      || document.documentElement.clientHeight
      || 0
    );
    const getViewportWidth = () => (
      (window.visualViewport && window.visualViewport.width)
      || window.innerWidth
      || document.documentElement.clientWidth
      || 0
    );

    const scheduleUpdate = () => {
      if (state.raf) return;

      state.raf = requestAnimationFrame(() => {
        state.raf = null;
        state.instances.forEach((instance) => instance.update());
      });
    };

    const scheduleMeasure = () => {
      if (state.resizeRaf) cancelAnimationFrame(state.resizeRaf);

      state.resizeRaf = requestAnimationFrame(() => {
        state.resizeRaf = null;
        state.instances.forEach((instance) => instance.measure());
      });
    };

    const handleResize = () => {
      const nextWidth = document.documentElement.clientWidth || window.innerWidth || 0;
      const widthChanged = Math.abs(nextWidth - state.lastViewportWidth) > 1;
      state.lastViewportWidth = nextWidth;

      if (!state.desktopQuery.matches && !widthChanged) {
        scheduleUpdate();
        return;
      }

      scheduleMeasure();
    };

    const setupSection = (section) => {
      if (!section || state.instances.has(section)) return;

      const stage = section.querySelector('[data-scroll-bento-stage]');
      const viewport = section.querySelector('[data-scroll-bento-viewport]');
      const grid = section.querySelector('[data-scroll-bento-grid]');
      const measureContainer = section.querySelector('[data-scroll-bento-container-measure]');
      const tiles = Array.from(section.querySelectorAll('[data-scroll-bento-tile]'));

      if (!stage || !viewport || !grid || tiles.length < 2) return;

      const focalIndex = Number.parseInt(section.dataset.scrollBentoFocalTile, 10) - 1;
      const focalWidthMode = section.dataset.scrollBentoFocalWidth || 'container';
      const mobileViewportHeightPercent = clamp(Number.parseFloat(section.dataset.scrollBentoViewportHeightMobile) || 100, 1, 200) / 100;
      const headingFadeEnd = section.dataset.scrollBentoHeadingFadeEnd || '20';
      const overlayFadeStart = section.dataset.scrollBentoOverlayFadeStart || '20';
      const overlayFadeEnd = section.dataset.scrollBentoOverlayFadeEnd || '60';
      const overlayMaxOpacity = clamp(Number.parseFloat(section.dataset.scrollBentoOverlayMaxOpacity) || 0, 0, 1);

      const instance = {
        transforms: [],
        reduced: false,
        scrollStart: 0,
        scrollDistance: 1,
        mobileStartHeight: 0,
        mobileFinalHeight: 0,
        clear() {
          grid.classList.remove('is-final-layout', 'is-absolute-layout');
          grid.style.clipPath = '';
          section.style.setProperty('--scroll-bento-heading-opacity', '0');
          section.style.setProperty('--scroll-bento-overlay-opacity', '0');
          section.style.setProperty('--scroll-bento-clip-bottom', '0px');
          section.style.setProperty('--scroll-bento-current-mobile-height', 'var(--scroll-bento-mobile-start-height)');
          tiles.forEach((tile) => {
            tile.style.transform = '';
            tile.style.width = '';
            tile.style.height = '';
            tile.style.opacity = '';
            tile.style.zIndex = '';
            tile.style.removeProperty('--scroll-bento-image-scale');
          });
        },
        measure() {
          this.reduced = state.reduceMotionQuery.matches;
          this.transforms = [];
          this.clipBottomFinal = 0;
          this.mobileStickyTop = 0;
          this.clear();

          if (this.reduced) {
            section.style.setProperty('--scroll-bento-heading-opacity', '1');
            section.style.setProperty('--scroll-bento-overlay-opacity', overlayMaxOpacity.toFixed(3));
            return;
          }

          const isDesktop = state.desktopQuery.matches;
          const gridRect = grid.getBoundingClientRect();
          const viewportRect = viewport.getBoundingClientRect();
          const containerRect = measureContainer ? measureContainer.getBoundingClientRect() : gridRect;
          const firstRects = tiles.map((tile) => tile.getBoundingClientRect());
          const gridStyle = getComputedStyle(grid);
          const viewportStyle = getComputedStyle(viewport);
          const finalGap = parseFloat(gridStyle.columnGap || gridStyle.gap) || 8;
          const viewportLeft = viewportRect.left - gridRect.left;
          const viewportTop = viewportRect.top - gridRect.top;
          const screenWidth = getViewportWidth() || viewportRect.width;
          const mobileStickyTop = isDesktop ? 0 : Math.max(0, Number.parseFloat(viewportStyle.top) || 0);
          const browserViewportHeight = getViewportHeight() || viewportRect.height;
          const screenHeight = isDesktop
            ? browserViewportHeight
            : Math.max(viewportRect.height, browserViewportHeight * mobileViewportHeightPercent);

          this.mobileStickyTop = mobileStickyTop;
          this.mobileStartHeight = isDesktop ? viewportRect.height : gridRect.height;
          this.mobileFinalHeight = Math.max(viewportRect.height, screenHeight);
          this.scrollStart = stage.getBoundingClientRect().top + window.scrollY - mobileStickyTop;
          this.scrollDistance = Math.max(
            1,
            stage.offsetHeight - (isDesktop ? viewport.offsetHeight : this.mobileStartHeight)
          );

          const hasFocal = (
            Number.isFinite(focalIndex)
            && focalIndex >= 0
            && focalIndex < firstRects.length
            && viewportRect.width > 0
            && viewportRect.height > 0
          );

          const aspectFor = (tile, rect) => {
            const rawAspect = Number.parseFloat(tile.dataset.scrollBentoAspectRatio || '');
            if (Number.isFinite(rawAspect) && rawAspect > 0) return rawAspect;
            return rect.height > 0 ? rect.width / rect.height : 1.5;
          };

          const areaFor = (index) => {
            const desktopAreas = [
              { column: 0, row: 0, columnSpan: 1, rowSpan: 2 },
              { column: 1, row: 0, columnSpan: 1, rowSpan: 1 },
              { column: 1, row: 1, columnSpan: 1, rowSpan: 2 },
              { column: 2, row: 0, columnSpan: 1, rowSpan: 2 },
              { column: 0, row: 2, columnSpan: 1, rowSpan: 1 },
              { column: 2, row: 2, columnSpan: 1, rowSpan: 2 },
              { column: 0, row: 3, columnSpan: 1, rowSpan: 1 },
              { column: 1, row: 3, columnSpan: 1, rowSpan: 1 },
            ];

            return desktopAreas[index] || {
              column: index % 3,
              row: Math.floor(index / 3),
              columnSpan: 1,
              rowSpan: 1,
            };
          };

          grid.classList.add('is-final-layout');
          const finalRects = tiles.map((tile) => tile.getBoundingClientRect());
          grid.classList.remove('is-final-layout');

          let targetRects = null;

          if (hasFocal) {
            const areas = tiles.map((tile, index) => areaFor(index));
            const focalArea = areas[focalIndex];

            if (isDesktop) {
              const focalFirst = firstRects[focalIndex];
              const focalAspect = aspectFor(tiles[focalIndex], focalFirst);
              const maxContainerWidth = focalWidthMode === 'viewport' ? viewportRect.width : containerRect.width;
              let focalWidth = Math.min(maxContainerWidth || viewportRect.width, viewportRect.width - (finalGap * 2));
              let focalHeight = focalWidth / focalAspect;

              if (focalHeight > viewportRect.height * 0.92) {
                focalHeight = viewportRect.height * 0.92;
                focalWidth = focalHeight * focalAspect;
              }

              const focalX = viewportLeft + ((viewportRect.width - focalWidth) / 2);
              const focalY = viewportTop + ((viewportRect.height - focalHeight) / 2);
              const finalColumnWidth = Math.max(1, (focalWidth - (finalGap * (focalArea.columnSpan - 1))) / focalArea.columnSpan);
              const finalRowHeight = Math.max(1, (focalHeight - (finalGap * (focalArea.rowSpan - 1))) / focalArea.rowSpan);
              const finalGridX = focalX - (focalArea.column * (finalColumnWidth + finalGap));
              const finalGridY = focalY - (focalArea.row * (finalRowHeight + finalGap));
              this.clipBottomFinal = Math.max(0, (viewportTop + viewportRect.height) - (focalY + focalHeight));

              targetRects = areas.map((area) => ({
                x: finalGridX + (area.column * (finalColumnWidth + finalGap)),
                y: finalGridY + (area.row * (finalRowHeight + finalGap)),
                width: (area.columnSpan * finalColumnWidth) + ((area.columnSpan - 1) * finalGap),
                height: (area.rowSpan * finalRowHeight) + ((area.rowSpan - 1) * finalGap),
              }));
            } else {
              const columnCount = Math.max(3, ...areas.map((area) => area.column + area.columnSpan));
              const rowCount = Math.max(1, ...areas.map((area) => area.row + area.rowSpan));
              const columnWeights = Array.from({ length: columnCount }, (item, index) => (
                index === 0 ? 1 : index === 1 ? 3 : index === 2 ? 1 : 1
              ));
              const totalColumnWeight = columnWeights.reduce((sum, weight) => sum + weight, 0);
              const finalGridWidth = Math.max(1, screenWidth);
              const finalGridHeight = Math.max(1, screenHeight);
              const finalColumnWidth = Math.max(1, finalGridWidth - (finalGap * (columnCount - 1)));
              const finalRowHeight = Math.max(1, (finalGridHeight - (finalGap * (rowCount - 1))) / rowCount);
              const columnWidths = columnWeights.map((weight) => finalColumnWidth * (weight / totalColumnWeight));
              const columnOffsets = columnWidths.reduce((offsets, width, index) => {
                offsets.push(index === 0 ? 0 : offsets[index - 1] + columnWidths[index - 1] + finalGap);
                return offsets;
              }, []);
              const finalGridX = -gridRect.left;
              const finalGridY = viewportTop;
              this.clipBottomFinal = 0;

              targetRects = areas.map((area) => {
                const spannedColumns = columnWidths.slice(area.column, area.column + area.columnSpan);
                const width = spannedColumns.reduce((sum, columnWidth) => sum + columnWidth, 0) + (finalGap * (area.columnSpan - 1));

                return {
                  x: finalGridX + columnOffsets[area.column],
                  y: finalGridY + (area.row * (finalRowHeight + finalGap)),
                  width,
                  height: (area.rowSpan * finalRowHeight) + ((area.rowSpan - 1) * finalGap),
                };
              });
            }
          }

          this.transforms = tiles.map((tile, index) => {
            const first = firstRects[index];
            const final = finalRects[index];
            const target = targetRects && targetRects[index];
            const x2 = target ? target.x : final.left - gridRect.left;
            const y2 = target ? target.y : final.top - gridRect.top;
            const width2 = target ? target.width : final.width;
            const height2 = target ? target.height : final.height;
            let zIndex = index === focalIndex ? 3 : 1;

            return {
              x1: first.left - gridRect.left,
              y1: first.top - gridRect.top,
              width1: first.width,
              height1: first.height,
              x2,
              y2,
              width2,
              height2,
              opacity1: 1,
              opacity2: 1,
              imageScale1: isDesktop ? 1 : (index === focalIndex ? 1.18 : 1.1),
              imageScale2: isDesktop ? 1 : (index === focalIndex ? 1 : 1.04),
              zIndex,
            };
          });

          grid.classList.add('is-absolute-layout');
          this.update(true);
        },
        update() {
          if (this.reduced || !this.transforms.length) return;

          const isDesktop = state.desktopQuery.matches;
          const progress = clamp((window.scrollY - this.scrollStart) / this.scrollDistance, 0, 1);
          const headingOpacity = progressBetween(progress, 0, headingFadeEnd);
          const overlayProgress = progressBetween(progress, overlayFadeStart, overlayFadeEnd);
          const clipProgress = clamp((progress - 0.72) / 0.28, 0, 1);
          const clipBottom = this.clipBottomFinal ? this.clipBottomFinal * clipProgress : 0;

          section.style.setProperty('--scroll-bento-heading-opacity', headingOpacity.toFixed(3));
          section.style.setProperty('--scroll-bento-overlay-opacity', (overlayProgress * overlayMaxOpacity).toFixed(3));
          section.style.setProperty('--scroll-bento-clip-bottom', `${clipBottom.toFixed(2)}px`);
          if (!isDesktop) {
            const currentHeight = this.mobileStartHeight + ((this.mobileFinalHeight - this.mobileStartHeight) * progress);
            section.style.setProperty('--scroll-bento-current-mobile-height', `${currentHeight.toFixed(2)}px`);
          }
          grid.style.clipPath = clipBottom > 0.5 ? `inset(0px 0px ${clipBottom}px 0px)` : '';

          tiles.forEach((tile, index) => {
            const transform = this.transforms[index];
            if (!transform) return;

            const x = transform.x1 + ((transform.x2 - transform.x1) * progress);
            const y = transform.y1 + ((transform.y2 - transform.y1) * progress);
            const width = transform.width1 + ((transform.width2 - transform.width1) * progress);
            const height = transform.height1 + ((transform.height2 - transform.height1) * progress);
            const opacity = transform.opacity1 + ((transform.opacity2 - transform.opacity1) * progress);
            const imageScale = transform.imageScale1 + ((transform.imageScale2 - transform.imageScale1) * progress);

            tile.style.width = `${width}px`;
            tile.style.height = `${height}px`;
            tile.style.opacity = opacity.toFixed(3);
            tile.style.zIndex = transform.zIndex;
            tile.style.setProperty('--scroll-bento-image-scale', imageScale.toFixed(4));
            tile.style.transform = `translate3d(${x}px, ${y}px, 0)`;
          });
        },
        destroy() {
          this.clear();
          state.instances.delete(section);
        },
      };

      state.instances.set(section, instance);

      section.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', scheduleMeasure, { once: true });
      });

      instance.measure();
    };

    const setupAll = () => {
      document.querySelectorAll('[data-scroll-bento-gallery]').forEach((section) => setupSection(section));
    };

    if (!state.initialized) {
      state.initialized = true;

      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', handleResize);
      if (state.reduceMotionQuery.addEventListener) {
        state.reduceMotionQuery.addEventListener('change', scheduleMeasure);
      } else if (state.reduceMotionQuery.addListener) {
        state.reduceMotionQuery.addListener(scheduleMeasure);
      }

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.matches && event.target.matches('[data-scroll-bento-gallery]')) {
          setupSection(event.target);
        }

        event.target.querySelectorAll('[data-scroll-bento-gallery]').forEach((section) => setupSection(section));
      });

      document.addEventListener('shopify:section:unload', (event) => {
        state.instances.forEach((instance, section) => {
          if (event.target === section || event.target.contains(section)) {
            instance.destroy();
          }
        });
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupAll, { once: true });
      }
    }

    if (!state.desktopQueryListenerInitialized) {
      state.desktopQueryListenerInitialized = true;

      if (state.desktopQuery.addEventListener) {
        state.desktopQuery.addEventListener('change', scheduleMeasure);
      } else if (state.desktopQuery.addListener) {
        state.desktopQuery.addListener(scheduleMeasure);
      }
    }

    setupAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-reveal-media"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registryKey = '__ksScrollRevealMedia';
    const state = window[registryKey] || {
      initialized: false,
      instances: new Set(),
      raf: null,
      reduceMotion: window.matchMedia('(prefers-reduced-motion: reduce)'),
      mobile: window.matchMedia('(max-width: 767px)'),
    };

    window[registryKey] = state;

    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const rangeProgress = (value, start, end) => clamp((value - start) / Math.max(0.001, end - start));

    const updateAll = () => {
      state.raf = null;
      state.instances.forEach((instance) => instance.update());
    };

    const scheduleUpdate = () => {
      if (state.raf) return;
      state.raf = requestAnimationFrame(updateAll);
    };

    const setup = (section) => {
      if (!section || section.dataset.scrollRevealInitialized === 'true') return;

      const stage = section.querySelector('[data-scroll-reveal-stage]');
      if (!stage) return;

      section.dataset.scrollRevealInitialized = 'true';

      const instance = {
        section,
        update() {
          if (state.reduceMotion.matches) {
            section.style.setProperty('--ks-scroll-reveal-inset-x', '0%');
            section.style.setProperty('--ks-scroll-reveal-inset-y', '0%');
            section.style.setProperty('--ks-scroll-reveal-media-scale', '1');
            section.style.setProperty('--ks-scroll-reveal-overlay-opacity', 'var(--ks-scroll-reveal-overlay-max)');
            section.style.setProperty('--ks-scroll-reveal-content-opacity', '1');
            section.style.setProperty('--ks-scroll-reveal-content-y', '0px');
            return;
          }

          const rect = section.getBoundingClientRect();
          const distance = Math.max(1, section.offsetHeight - stage.offsetHeight);
          const progress = clamp(-rect.top / distance);
          const revealProgress = rangeProgress(progress, 0, 0.28);
          const contentProgress = rangeProgress(progress, 0.24, 0.58);
          const mobile = state.mobile.matches;
          const startInsetX = mobile ? 10 : 18;
          const startInsetY = mobile ? 7 : 10;
          const startScale = mobile ? 1.05 : 1.08;
          const startContentY = mobile ? 28 : 48;
          const overlayMax = Number.parseFloat(getComputedStyle(section).getPropertyValue('--ks-scroll-reveal-overlay-max')) || 0;

          section.style.setProperty('--ks-scroll-reveal-inset-x', `${(startInsetX * (1 - revealProgress)).toFixed(3)}%`);
          section.style.setProperty('--ks-scroll-reveal-inset-y', `${(startInsetY * (1 - revealProgress)).toFixed(3)}%`);
          section.style.setProperty('--ks-scroll-reveal-media-scale', (startScale - ((startScale - 1) * revealProgress)).toFixed(4));
          section.style.setProperty('--ks-scroll-reveal-overlay-opacity', (overlayMax * contentProgress).toFixed(3));
          section.style.setProperty('--ks-scroll-reveal-content-opacity', contentProgress.toFixed(3));
          section.style.setProperty('--ks-scroll-reveal-content-y', `${(startContentY * (1 - contentProgress)).toFixed(2)}px`);
        },
        destroy() {
          state.instances.delete(instance);
          delete section.dataset.scrollRevealInitialized;
        },
      };

      state.instances.add(instance);
      instance.update();
    };

    const setupAll = (scope = document) => {
      if (scope.matches?.('[data-scroll-reveal-media]')) setup(scope);
      scope.querySelectorAll?.('[data-scroll-reveal-media]').forEach(setup);
    };

    if (!state.initialized) {
      state.initialized = true;
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      state.reduceMotion.addEventListener?.('change', scheduleUpdate);
      state.mobile.addEventListener?.('change', scheduleUpdate);
      document.addEventListener('shopify:section:load', (event) => {
        setupAll(event.target);
        scheduleUpdate();
      });
      document.addEventListener('shopify:section:unload', (event) => {
        state.instances.forEach((instance) => {
          if (event.target.contains(instance.section)) instance.destroy();
        });
      });
    }

    setupAll();
    scheduleUpdate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registryKey = '__ksStoryTimeline';
    const state = window[registryKey] || { initialized: false, instances: new Set() };
    window[registryKey] = state;
    if (!state.instances) state.instances = new Set();

    const setup = (section) => {
      if (!section || section.dataset.storyTimelineInitialized === 'true') return;

      const track = section.querySelector('[data-story-timeline-track]');
      const cards = Array.from(section.querySelectorAll('[data-story-timeline-card]'));
      const yearButtons = Array.from(section.querySelectorAll('[data-story-timeline-year]'));
      const previous = section.querySelector('[data-story-timeline-prev]');
      const next = section.querySelector('[data-story-timeline-next]');
      const rail = section.querySelector('[data-story-timeline-rail]');

      if (!track || cards.length === 0) return;
      section.dataset.storyTimelineInitialized = 'true';

      let activeIndex = -1;
      let raf = null;

      const leftForCard = (card) => {
        const scrollPadding = Number.parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
        return Math.max(0, card.offsetLeft - track.offsetLeft - scrollPadding);
      };
      const setActive = (index, moveRail = true) => {
        const nextIndex = Math.max(0, Math.min(cards.length - 1, index));
        const changed = nextIndex !== activeIndex;
        activeIndex = nextIndex;

        yearButtons.forEach((button, buttonIndex) => {
          const active = buttonIndex === activeIndex;
          button.classList.toggle('is-active', active);
          if (active) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });

        if (previous) previous.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === cards.length - 1;

        if (moveRail && changed && rail && yearButtons[activeIndex]) {
          const button = yearButtons[activeIndex];
          const buttonCenter = button.offsetLeft + (button.offsetWidth / 2);
          const railLeft = buttonCenter - (rail.clientWidth / 2);
          rail.scrollTo({ left: Math.max(0, railLeft), behavior: 'smooth' });
        }
      };

      const nearestIndex = () => {
        let nearest = 0;
        let distance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const delta = Math.abs(leftForCard(card) - track.scrollLeft);
          if (delta < distance) {
            distance = delta;
            nearest = index;
          }
        });

        return nearest;
      };

      const handleScroll = () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;
          setActive(nearestIndex());
        });
      };

      const goTo = (index) => {
        const targetIndex = Math.max(0, Math.min(cards.length - 1, index));
        const target = cards[targetIndex];
        if (!target) return;
        setActive(targetIndex);
        track.scrollTo({ left: leftForCard(target), behavior: 'smooth' });
      };

      const onPrevious = () => goTo(activeIndex - 1);
      const onNext = () => goTo(activeIndex + 1);
      const onYearClick = (event) => goTo(Number(event.currentTarget.dataset.storyTimelineYear || 0));

      previous?.addEventListener('click', onPrevious);
      next?.addEventListener('click', onNext);
      yearButtons.forEach((button) => button.addEventListener('click', onYearClick));
      track.addEventListener('scroll', handleScroll, { passive: true });
      window.addEventListener('resize', handleScroll, { passive: true });

      setActive(0, false);

      const instance = {
        section,
        destroy() {
          if (raf) cancelAnimationFrame(raf);
          previous?.removeEventListener('click', onPrevious);
          next?.removeEventListener('click', onNext);
          yearButtons.forEach((button) => button.removeEventListener('click', onYearClick));
          track.removeEventListener('scroll', handleScroll);
          window.removeEventListener('resize', handleScroll);
          state.instances.delete(instance);
          delete section.dataset.storyTimelineInitialized;
        },
      };

      state.instances.add(instance);
    };

    const setupAll = (scope = document) => {
      if (scope.matches?.('[data-story-timeline]')) setup(scope);
      scope.querySelectorAll?.('[data-story-timeline]').forEach(setup);
    };

    if (!state.initialized) {
      state.initialized = true;
      document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        state.instances.forEach((instance) => {
          if (event.target.contains(instance.section)) instance.destroy();
        });
      });
    }

    setupAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonials-slider')) {
    customElements.define('testimonials-slider', class TestimonialsSlider extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.track = this.querySelector('[data-testimonials-track]');
        this.slides = [...this.querySelectorAll('[data-testimonial-slide]')];
        this.previousButtons = [...this.querySelectorAll('[data-testimonials-prev]')];
        this.nextButtons = [...this.querySelectorAll('[data-testimonials-next]')];
        this.status = this.querySelector('[data-testimonials-status]');
        this.currentIndex = 0;

        if (!this.track || this.slides.length === 0) return;

        this.handleKeydown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(this.currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
        };

        this.track.addEventListener('keydown', this.handleKeydown);

        this.previousButtons.forEach((button) => {
          button.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        });
        this.nextButtons.forEach((button) => {
          button.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        });
        this.addEventListener('shopify:block:select', (event) => {
          const selectedSlide = event.target.closest('[data-testimonial-slide]');
          const selectedIndex = this.slides.indexOf(selectedSlide);
          if (selectedIndex < 0) return;
          this.goTo(selectedIndex);
        });

        this.goTo(0);
      }

      goTo(index) {
        if (!this.track || this.slides.length === 0) return;
        const nextIndex = (index + this.slides.length) % this.slides.length;

        this.update(nextIndex);
      }

      update(index) {
        this.currentIndex = index;
        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.toggleAttribute('inert', !isActive);
        });

        if (this.status) {
          this.status.textContent = `Testimonial ${index + 1} of ${this.slides.length}`;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
